import { Button, Input, Table, Tooltip } from 'antd';
import API from 'API';
import React, { useCallback, useEffect, useState } from 'react'
import { FormOutlined, FundOutlined, SaveOutlined, UnorderedListOutlined } from '@ant-design/icons'
import { colorSet } from 'const';
import { correct_media, downloadFile } from 'general_function';

function getColor(score) {
    if (score < 0.5) return colorSet["low"];
    if (score < 0.8) return colorSet["medium"];
    return colorSet["high"]
}

export default function StudentHandle({ course, selectedTerm}) {
    const [columns, setColumns] = useState([]);
    const [students, setStudents] = useState({
        page: 1,
        count: 0,
        students: []
    });
    const [gettingData, setGettingData] = useState(true);
    const [search, setSearch] = useState("");
    const [downloading, setDownloading] = useState(false);

    useEffect(() => {
        setGettingData(true);
        API.post("/handle-student-in-course/", {
            term_id: selectedTerm.id,
            course_id: course.id,
            page: students.page,
            page_size: students.pageSize,
            name: search
        })
        .then(res => {
            setColumns([
                {title: "Sinh viên", key: "full_name", render: (value) => <>{value.last_name} {value.first_name}</>},
                ...res.data.columns.map(item => ({
                title: item.name,
                key: item.id,
                render: (value) => <>
                    <Tooltip title="Tiến trình học">
                        <span style={{ color: getColor(+(value[`scorm_progress_${item.id}`]?.["cmi.progress_measure"] || 0)) }}>
                            <FundOutlined /> : {+(value[`scorm_progress_${item.id}`]?.["cmi.progress_measure"] || 0)*100}%
                        </span>
                    </Tooltip><br />
                    <Tooltip title="Trắc nghiệm đã làm">
                        <span style={{ color: getColor(value[`quiz_count_${item.id}`]/item.total_quiz) }}>
                            <UnorderedListOutlined />: {value[`quiz_count_${item.id}`]}/{item.total_quiz}
                        </span>
                    </Tooltip><br />
                    <Tooltip title="Tự luận đã làm">
                        <span style={{ color: getColor(value[`essay_count_${item.id}`]/item.total_essay) }}>
                            <FormOutlined />: {value[`essay_count_${item.id}`]}/{item.total_essay}
                        </span>
                    </Tooltip>
                </>
            }))]);
            setStudents({
                students: res.data.students,
                page: students.page,
                count: res.data.count,
                pageSize: students.pageSize,
            })
            setGettingData(false);
        })
        .catch(error => {
            console.log(error);
        })
    },[course.id, selectedTerm.id, students.page, students.pageSize, search])

    const handleDownload = useCallback(() => {
        setDownloading(true);
        API.post("/handle-student-in-course/", {
            term_id: selectedTerm.id,
            name: search,
            export: true,
            course_id: course.id,
        })
        .then(res => {
            const path = correct_media(res.data);
            downloadFile(path);
        })
        .catch(error => {

        })
        .finally(() => {
            setDownloading(false);
        })
    },[search, selectedTerm.id, course.id])

    return <>
        <Input.Search 
            placeholder='Tìm sinh viên'
            onSearch={setSearch}
            style={{ width: 400, marginRight: 3 }}
            disabled={gettingData}
            allowClear
        />
        <Button type='primary' loading={downloading} disabled={downloading} onClick={handleDownload}>
            Tải file <SaveOutlined />
        </Button>
        <Table 
            rowKey="id"
            columns={columns}
            dataSource={students.students}
            loading={gettingData}
            pagination={{
                current: students.page,
                pageSize: students.pageSize,
                showSizeChanger: true,
                onChange: (page, pageSize) => setStudents({...students, page: page, pageSize: pageSize}),
                total: students.count,
                position: ["bottomLeft"],
            }}
        />
    </>
}
